import React from 'react'
import { Registros } from '../../layouts/RegistrosMobile/Registros'

export function PageRegistros() {
  return (
    <Registros />
  )
}
